
import React from 'react';
import './Experiences.css';

const Experiences = () => {
    const experiences = [
        {
            title: "Founding Engineer",
            company: "Scoutrex (Pakistan's First AI Scouting Platform)",
            location: "Islamabad, Pakistan",
            duration: "Jan 2025 – Jan 2026"
        },
        {
            title: "AI/ML Engineer",
            company: "The Bloodstock Connection",
            location: "Remote",
            duration: "July 2025 – Nov 2025"
        },
        {
            title: "Intern – Technology Department",
            company: "Pakistan TV",
            location: "Islamabad, Pakistan",
            duration: "Aug 2025 – Oct 2025"
        },
        {
            title: "Intern",
            company: "iENGINEERING PVT Ltd",
            location: "Islamabad, Pakistan",
            duration: "July 2025 – Aug 2025"
        },
        {
            title: "Software Developer",
            company: "SOLKAI Technologies",
            location: "Islamabad, Pakistan",
            duration: "Aug 2024 – Jan 2025"
        }
    ];

    const education = [
        {
            title: "BS in Computer Science",
            company: "FAST National University of Computer and Emerging Sciences",
            location: "Islamabad, Pakistan",
            duration: "2021 – 2025",
            responsibilities: [
                "Relevant Coursework: Artificial Intelligence, Computer Vision, Cloud Computing, Generative AI, Software Project Management, Software Engineering, Software for Mobile Development, Data Structures"
            ]
        }
    ];

    return (
        <section id="experiences" className="section">
            <div className="experiences-container">
                <div className="experiences-heading-wrapper">
                    <h2>Experience</h2>
                </div>
                <div className="experiences-content">
                    {experiences.map((exp, index) => (
                        <div key={index} className="experience-item">
                            <div className="experience-header">
                                <h3>{exp.title}</h3>
                                <span className="experience-duration">{exp.duration}</span>
                            </div>
                            <div className="experience-company">
                                <span className="company-name">{exp.company}</span>
                                <span className="experience-location">{exp.location}</span>
                            </div>
                            {exp.responsibilities && (
                                <ul className="experience-responsibilities">
                                    {exp.responsibilities.map((resp, idx) => (
                                        <li key={idx}>{resp}</li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    ))}
                </div>

                <div className="experiences-heading-wrapper education-heading">
                    <h2>Education</h2>
                </div>
                <div className="experiences-content">
                    {education.map((edu, index) => (
                        <div key={index} className="experience-item">
                            <div className="experience-header">
                                <h3>{edu.title}</h3>
                                <span className="experience-duration">{edu.duration}</span>
                            </div>
                            <div className="experience-company">
                                <span className="company-name">{edu.company}</span>
                                <span className="experience-location">{edu.location}</span>
                            </div>
                            {edu.responsibilities && (
                                <ul className="experience-responsibilities">
                                    {edu.responsibilities.map((resp, idx) => (
                                        <li key={idx}>{resp}</li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Experiences;
